import './footer.css';

export default function Footer() {
  return (
    <footer className="footer">

      {/* ── Top: Statement CTA + Info ── */}
      <div className="footer-top">
        <div className="footer-top-left">
          <span className="footer-eyebrow">· Let's create something beautiful ·</span>
          <h2 className="footer-headline">
            Ready for<br /><em>your next</em><br />look?
          </h2>
          <a href="sms:+14016225651" className="footer-cta">
            <span>Book Appointment</span>
            <span className="footer-cta-arrow">→</span>
          </a>
        </div>

        <div className="footer-top-right">
          <div className="footer-info-block">
            <span className="footer-info-label">Find Me</span>
            <p>9 East Ave<br />Westerly, RI 02891</p>
          </div>

          <div className="footer-info-block">
            <span className="footer-info-label">Text Me</span>
            <a href="sms:+14016225651">(+1) 401 622 5651</a>
          </div>

          <div className="footer-info-block">
            <span className="footer-info-label">Hours</span>
            <div className="footer-hours-mini">
              <div><span>Sun &amp; Mon</span><span>Closed</span></div>
              <div><span>Tues</span><span>10a – 7p</span></div>
              <div><span>Wed</span><span>Closed</span></div>
              <div><span>Thurs &amp; Fri</span><span>9a – 7p</span></div>
              <div><span>Sat</span><span>10a – 3p</span></div>
            </div>
          </div>
        </div>
      </div>

      

      {/* ── Nav Bar ── */}
      <nav className="footer-nav">
        <a href="#hero">Home</a>
        <a href="#services">Services</a>
        <a href="#gallery">Gallery</a>
        <a href="#hours">Hours</a>
        <span className="footer-nav-copy">© 2026 Hair by Katheryne · Westerly, RI</span>
      </nav>

{/* ── Marquee Strip ── */}
      <div className="footer-marquee-wrap" aria-hidden="true">
        <div className="footer-marquee">
          <span className="footer-marquee-set">
            <span>Hair by Katheryne</span>
            <span className="footer-dot">·</span>
            <span>Expert Color &amp; Care</span>
            <span className="footer-dot">·</span>
            <span>Westerly, Rhode Island</span>
            <span className="footer-dot">·</span>
            <span>Book Your Appointment</span>
            <span className="footer-dot">·</span>
          </span>
          <span className="footer-marquee-set" aria-hidden="true">
            <span>Hair by Katheryne</span>
            <span className="footer-dot">·</span>
            <span>Expert Color &amp; Care</span>
            <span className="footer-dot">·</span>
            <span>Westerly, Rhode Island</span>
            <span className="footer-dot">·</span>
            <span>Book Your Appointment</span>
            <span className="footer-dot">·</span>
          </span>
        </div>
      </div>

    </footer>
  );
}
